import { use } from "react";
import { AuthSheetContext, type AuthSheetApi } from "#auth-sheet-context";

export type { AuthSheetApi } from "#auth-sheet-context";

export function useAuthSheet(): AuthSheetApi {
  const api = use(AuthSheetContext);
  if (api === null) {
    throw new Error("useAuthSheet must be used inside an AuthSheetProvider");
  }
  return api;
}
